import { useNavigate } from 'react-router-dom'
import { Auth0LoginButton } from 'grabbitbot-legacy-ui'
import { AUTH0_LOGIN_EXPECTED_ORIGIN, AUTH0_LOGIN_URL, POST_LOGIN_PATH } from '../../config'

// Equivalent of legacy `UserPasswordForgotSetComponent`. 2026-09-26 (owner
// decision, legacy-migration/RULES.md): `PATCH /user/password/forgot/set`
// now returns `410` — an old emailed reset link landing here can no longer
// be completed on this page. Kept registered (so the link shows a clear
// notice instead of a 404) and points at Auth0 sign-in, which owns password
// reset going forward.
export function PasswordForgotSetPage() {
  const navigate = useNavigate()
  return (
    <div className="screener-card screener-card--auth">
      <p role="alert">
        This password-reset link is no longer valid — password reset now
        happens through sign-in.
      </p>
      <Auth0LoginButton
        popupUrl={AUTH0_LOGIN_URL}
        expectedOrigin={AUTH0_LOGIN_EXPECTED_ORIGIN}
        onSuccess={() => navigate(POST_LOGIN_PATH, { replace: true })}
      >
        Log in
      </Auth0LoginButton>
    </div>
  )
}
